


import {Component, Prop, Vue} from 'vue-property-decorator'
import {ICustomerExtendData} from "@/entities";

@Component
export default class SubjectEmail extends Vue {
  @Prop() readonly person?: ICustomerExtendData

  get recipient(): string {
    const email = this.person?.email;
    return email ? `<span class="strong">${ email }</span>` : this.$t('your-email') as string;
  }

}
